module.exports = __webpack_public_path__ + "media/images/awards/logo-6be096a0ccb8eadb2f5ac9d6e046c244.png";